import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Ventas from "./components/SellScreen";
import Transcripcion1 from "./components/PruebaTranscripcion";
import Transcripcion2 from "./components/PruebaTranscripcion2";
import Transcripcion3 from "./components/PruebaTranscripcion3";
import Transcripcion4 from "./components/PruebaTranscripcion4";
import CallsHistory from "./components/CallsHistory";
import Stock from "./components/ReposicionScreen";
import DistribucionesDashboard from "./components/DistribucionesDashboard";
import RotacionInternaScreen from "./components/RotacionInternaScreen";
import CampaignScreen from "./components/CampaignScreen";
import ClientsScreen from "./components/Clients";
import CarrosAbandonadosScreen from "./components/CarrosAbandonados";
import OrdersScreen from "./components/Orders";
import NewClientsScreen from "./components/NewClientsScreen";


import Navbar from "./Navbar";
import NavbarXeroo from "./NavbarXeroo";
import NavbarLeads from "./NavbarXeroo";
import StatsDashboard from "./StatsDashboard";
import FraudCheckScreen from "./components/FraudCheckScreen";
import XerooClientLanding from "./components/Welcome";
import IASearchLanding from "./components/IASearch";
import StatsDailyDashboard from "./dailyConversations";
import { AuthProvider } from "./AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                {/* Rutas protegidas */}
                <Route
                    path="/doard"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <div className="container mx-auto p-4 flex-1">

                                    <h2 className="text-2xl font-bold mb-4">Indicadores</h2>
                                    {/* <h2 className="text-2xl font-bold mb-4">Indicadores & Estadísticas</h2> */}
                                    <StatsDashboard />
                                    {/* <StatsDailyDashboard /> */}

                                    <hr className="my-8" />

                                    <h1 className="text-2xl font-bold mb-4">Conversaciones</h1>
                                    <Dashboard />

                                </div>
                                <ToastContainer />
                            </div>

                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <Ventas />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                  <Route
                    path="/pruebatranscripcion1"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                {/* <Navbar /> */}
                                <Transcripcion1 />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                         <Route
                    path="/pruebatranscripcion2"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                {/* <Navbar /> */}
                                <Transcripcion2 />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                         <Route
                    path="/pruebatranscripcion3"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                {/* <Navbar /> */}
                                <Transcripcion3 />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                            <Route
                    path="/pruebatranscripcion4"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                {/* <Navbar /> */}
                                <Transcripcion4 />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                                  <Route
                    path="/calls-history"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                {/* <Navbar /> */}
                                <CallsHistory />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/stock"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <Stock />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/distribucion"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <DistribucionesDashboard />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/rotacion"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <RotacionInternaScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/welcome"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLanding />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLanding />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}


